import React, { useEffect, useState } from "react";
import PendingOrdersTable from "../components/dashboard_components/pending_orders";
import { Ibox } from "../components/common/ibox";
import { PendingSampleData } from "../test/refactored_data/pending_sample_data";
import api from "../service/api";
import { ErrorLog, Log } from "../helpers/logs";
import { makeid } from "../helpers/helper_methods";

export default function PendingOrders(props) {
  const [orders, setOrders] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [orderBy, setOrderBy] = useState("stratification.rank");
  const [order, setOrder] = useState("desc");
  const [filterText, setFilterText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const [textLoading, setTextLoading] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(null);
  const [time, setTime] = useState(2000);

  useEffect(() => {
    getOrders();
  }, []);

  useEffect(() => {
    getOrders();
  }, [rowsPerPage, page, order, orderBy]);

  useEffect(() => {
    if (textLoading == true) {
      if (timer != null) {
        setTimer(() => clearTimeout(timer));

        setTimer(() => setTimeout(() => getOrders(), time));
      } else {
        setTimer(() => clearTimeout(timer));

        setTimer(() => setTimeout(() => getOrders(), time));
      }
    }
  }, [filterText]);

  function filterTextWrapper(e) {
    setTextLoading(() => true);
    setFilterText(() => e);
  }

  function getOrders() {
    var body = {};

    body.pagination = true;
    body.sort_header = orderBy;
    body.sort_order = order;
    body.page_number = page + 1;
    body.page_size = rowsPerPage;
    body.filter_text = filterText;
    body.pending = true;

    setTextLoading(() => false);
    setLoading(() => true);

    api.IConnectApi.getTests(body)
      .then((response) => {
        Log("Retrieved Orders");

        setLoading(() => false);

        setOrders(response.result.data);
        setTotalRecords(response.result.total_records);
      })
      .catch((er) => {
        setLoading(() => false);
        ErrorLog("Er: ", er);
      });
  }

  var pendingProps = {
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    orderBy,
    setOrderBy,
    order,
    setOrder,
    filterText,
    setFilterText: filterTextWrapper,
    totalRecords,
    data: PendingSampleData,
    orders,
    getOrders,
    pending: true,
    loading: textLoading || loading,
  };

  return (
    <Ibox
      id={`Pending IBox` + makeid(10)}
      enableTitleBar
      title={`Pending Orders`}
    >
      <PendingOrdersTable {...pendingProps} />
    </Ibox>
  );
}
